import { DateTime } from 'luxon'

export function sspDate(defaultValue: DateTime) {
	return {
		encode: (value: DateTime) => value.toISO(),
		decode: (value: string) => {
			if (value) {
				return DateTime.fromISO(value)
			}
			return null
		},
		defaultValue,
	}
}
